<template>
  <div id="write" class="is-mac">
    <h2>创作中心 - 帮助</h2>
    <div>基于「一起练琴」创作中心，用户可以上传自己的乐谱。在 App 里「在线乐谱库」里可以下载到自己的上传的乐谱。</div>
    <br>
    <div>如何使用「创作中心」，这里有一个 <a href="https://shimo.im/docs/Zg3oxO4dw8U0Fyqv" target="_blank">手把手的图文教程</a>。
    </div>
    <div>创作中心上传的乐谱，需要上传 <a href="https://shimo.im/docs/7wKnQPF9doYGXHsg" target="_blank">MuseScore 制谱软件</a>生成的文件。</div>
    <br>
    <div>使用 MuseScore 打谱有一定的门槛，我们准备了一个 <a href="https://shimo.im/docs/7wKnQPF9doYGXHsg" target="_blank">MuseScore 软件下载安装、基础使用</a>文档，特地为您准备了一个详细的<a
        href="https://creator.17lianqin.cn/video/musescore_guide"
        target="_blank"
      >MuseScore 使用视频教程</a>。
    </div>
    <div>为了 MuseScore 制作出来的乐谱更好地在「一起练琴」App 里使用，我们有一些 <a href="https://shimo.im/docs/xlkbElVjwyU9F9q8" target="_blank">录谱规范的要求</a>，需要遵守。</div>
    <br>
    <div>如果您也有打谱，但并不使用 MuseScore，则以下文档应该可以帮到您：</div>
    <ul>
        <li><a href="https://shimo.im/docs/zvk9dzdPDMIdFnq2" target="_blank">Sibelius 乐谱迁移到 MuseScore</a></li>
        <li><a href="https://shimo.im/docs/lnq8MwbJPMH6F4kw/" target="_blank">Overturn 乐谱迁移到 MuseScore</a></li>
    </ul>
    <div>很有可能，您是不会自己打谱的，毕竟学习制谱有一定的门槛。为此，我们给您推荐下述第三方独立录谱人员。这些录谱人员也曾经帮我们录制乐谱，他们熟悉<a href="https://shimo.im/docs/xlkbElVjwyU9F9q8" target="_blank">我们的乐谱规范</a>。</div>
    <ul>
      <li>吴老师：18582576283（微信同号）</li>
      <li>刘老师：15632310437</li>
      <li>钟老师：13479902065（微信同号）</li>
    </ul>
    <p>基于我们合作时的录谱价格，我们建议的价格如下：</p>
    <ul>
      <li>难度三级以下：20 元/页；</li>
      <li>难度四到六级：35 元/页；</li>
      <li>难度七级以上：50 元/页。</li>
    </ul>
    <p>上述价格为我们认为公允的价格，并且得到推荐打谱人员的认可。乐谱级别请自行协商。</p>
    <p><strong>特别声明：</strong>您与上述推荐打谱人员的合作，与「一起练琴」无关。如果合作不愉快，可向我们反馈，我们考虑不再把他列入推荐。
    </p>
    <p>欢迎加入「一起练琴打谱交流群」，请添加客服微信（扫二维码或加微信 QinQvQ），备注「创作中心交流群」，拉您进群。</p>
    <v-img src="https://creator.17lianqin.cn/public/wechatCode.png"></v-img>
  </div>
</template>

<script>
export default {
  name: "HandBookGuide",
  data: function() {
    return {};
  }
};
</script>

<style scoped>
html,
body {
  overflow-x: initial !important;
}
html {
  font-size: 14px;
  background-color: rgb(255, 255, 255);
  color: rgb(51, 51, 51);
}
body {
  margin: 0px;
  padding: 0px;
  height: auto;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  line-height: 1.42857143;
  overflow-x: hidden;
  background-image: inherit;
  background-size: inherit;
  background-attachment: inherit;
  background-origin: inherit;
  background-clip: inherit;
  background-color: inherit;
  background-position: inherit inherit;
  background-repeat: inherit inherit;
}
a:active,
a:hover {
  outline: 0px;
}
.in-text-selection,
::selection {
  background-color: rgb(181, 214, 252);
  text-shadow: none;
  background-position: initial initial;
  background-repeat: initial initial;
}
#write {
  margin: 0px auto;
  height: auto;
  width: inherit;
  word-break: normal;
  word-wrap: break-word;
  position: relative;
  padding-bottom: 70px;
  white-space: pre-wrap;
  overflow-x: auto;
}
.for-image #write {
  padding-left: 8px;
  padding-right: 8px;
}
body.typora-export {
  padding-left: 30px;
  padding-right: 30px;
}
@media screen and (max-width: 500px) {
  body.typora-export {
    padding-left: 0px;
    padding-right: 0px;
  }
  .CodeMirror-sizer {
    margin-left: 0px !important;
  }
  .CodeMirror-gutters {
    display: none !important;
  }
}
.typora-export #write {
  margin: 0px auto;
}
#write > p:first-child,
#write > ul:first-child,
#write > ol:first-child,
#write > pre:first-child,
#write > blockquote:first-child,
#write > div:first-child,
#write > table:first-child {
  margin-top: 30px;
}
#write li > table:first-child {
  margin-top: -20px;
}
img {
  max-width: 100%;
  vertical-align: middle;
}
input,
button,
select,
textarea {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-variant-caps: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  line-height: inherit;
}
input[type="checkbox"],
input[type="radio"] {
  line-height: normal;
  padding: 0px;
}
::before,
::after,
* {
  box-sizing: border-box;
}
#write p,
#write h1,
#write h2,
#write h3,
#write h4,
#write h5,
#write h6,
#write div,
#write pre {
  width: inherit;
}
#write p,
#write h1,
#write h2,
#write h3,
#write h4,
#write h5,
#write h6 {
  position: relative;
}
h1 {
  font-size: 2rem;
}
h2 {
  font-size: 1.8rem;
}
h3 {
  font-size: 1.6rem;
}
h4 {
  font-size: 1.4rem;
}
h5 {
  font-size: 1.2rem;
}
h6 {
  font-size: 1rem;
}
p {
  margin-block-start: 1rem;
  margin-block-end: 1rem;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.mathjax-block {
  margin-top: 0px;
  margin-bottom: 0px;
  margin-block-start: 0rem;
  margin-block-end: 0rem;
}
.hidden {
  display: none;
}
.md-blockmeta {
  color: rgb(204, 204, 204);
  font-weight: bold;
  font-style: italic;
}
a {
  cursor: pointer;
}
#write input[type="checkbox"] {
  cursor: pointer;
  width: inherit;
  height: inherit;
  margin: 4px 0px 0px;
}
tr {
  break-inside: avoid;
  break-after: auto;
}
thead {
  display: table-header-group;
}
table {
  border-collapse: collapse;
  border-spacing: 0px;
  width: 100%;
  overflow: auto;
  break-inside: auto;
  text-align: left;
}
table.md-table td {
  min-width: 80px;
}
.CodeMirror-gutters {
  border-right-width: 0px;
  background-color: inherit;
}
.CodeMirror {
  text-align: left;
}
.CodeMirror-placeholder {
  opacity: 0.3;
}
.CodeMirror pre {
  padding: 0px 4px;
}
.CodeMirror-lines {
  padding: 0px;
}
div.hr:focus {
  cursor: none;
}
pre {
  white-space: pre-wrap;
}
.CodeMirror-gutters {
  margin-right: 4px;
}
.md-fences {
  font-size: 0.9rem;
  display: block;
  break-inside: avoid;
  text-align: left;
  overflow: visible;
  white-space: pre;
  background-image: inherit;
  background-size: inherit;
  background-attachment: inherit;
  background-origin: inherit;
  background-clip: inherit;
  background-color: inherit;
  position: relative !important;
  background-position: inherit inherit;
  background-repeat: inherit inherit;
}
.md-diagram-panel {
  width: 100%;
  margin-top: 10px;
  text-align: center;
  padding-top: 0px;
  padding-bottom: 8px;
  overflow-x: auto;
}
.md-fences .CodeMirror.CodeMirror-wrap {
  top: -1.6em;
  margin-bottom: -1.6em;
}
.md-fences.mock-cm {
  white-space: pre-wrap;
}
.show-fences-line-number .md-fences {
  padding-left: 0px;
}
.show-fences-line-number .md-fences.mock-cm {
  padding-left: 40px;
}
.footnotes {
  opacity: 0.8;
  font-size: 0.9rem;
  padding-top: 1em;
  padding-bottom: 1em;
}
.footnotes + .footnotes {
  margin-top: -1em;
}
.md-reset {
  margin: 0px;
  padding: 0px;
  border: 0px;
  outline: 0px;
  vertical-align: top;
  background-color: transparent;
  text-decoration: none;
  text-shadow: none;
  float: none;
  position: static;
  width: auto;
  height: auto;
  white-space: nowrap;
  cursor: inherit;
  line-height: normal;
  font-weight: normal;
  text-align: left;
  box-sizing: content-box;
  direction: ltr;
  background-position: initial initial;
  background-repeat: initial initial;
}
li div {
  padding-top: 0px;
}
blockquote {
  margin: 1rem 0px;
}
li p,
li .mathjax-block {
  margin: 0.5rem 0px;
}
li {
  margin: 0px;
  position: relative;
}
blockquote > :last-child {
  margin-bottom: 0px;
}
blockquote > :first-child {
  margin-top: 0px;
}
.footnotes-area {
  color: rgb(136, 136, 136);
  margin-top: 0.714rem;
  padding-bottom: 0.143rem;
}
@media print {
  html,
  body {
    height: 100%;
  }
  .typora-export * {
    -webkit-print-color-adjust: exact;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    break-after: avoid-page;
    orphans: 2;
  }
  p {
    orphans: 4;
  }
  html.blink-to-pdf {
    font-size: 13px;
  }
  .typora-export #write {
    padding-left: 1cm;
    padding-right: 1cm;
  }
  .typora-export #write::after {
    height: 0px;
  }
  @page {
    margin: 20mm 0mm;
  }
}
.footnote-line {
  margin-top: 0.714em;
  font-size: 0.7em;
}
a img,
img a {
  cursor: pointer;
}
pre.md-meta-block {
  font-size: 0.8rem;
  min-height: 2.86rem;
  white-space: pre-wrap;
  background-color: rgb(204, 204, 204);
  display: block;
  overflow-x: hidden;
  background-position: initial initial;
  background-repeat: initial initial;
}
p .md-image:only-child {
  display: inline-block;
  width: 100%;
  text-align: center;
}
#write .MathJax_Display {
  margin: 0.8em 0px 0px;
}
.mathjax-block {
  white-space: pre;
  overflow: hidden;
  width: 100%;
}
p + .mathjax-block {
  margin-top: -1.143rem;
}
.mathjax-block:not(:empty)::after {
  display: none;
}
[contenteditable="true"]:active,
[contenteditable="true"]:focus {
  outline: none;
  box-shadow: none;
}
.task-list {
  list-style-type: none;
}
.task-list-item {
  position: relative;
  padding-left: 1em;
}
.task-list-item input {
  position: absolute;
  top: 0px;
  left: 0px;
}
.math {
  font-size: 1rem;
}
.md-toc {
  min-height: 3.58rem;
  position: relative;
  font-size: 0.9rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.md-toc-content {
  position: relative;
  margin-left: 0px;
}
.md-toc::after,
.md-toc-content::after {
  display: none;
}
.md-toc-item {
  display: block;
  color: rgb(65, 131, 196);
  text-decoration: none;
}
.md-toc-inner:hover {
}
.md-toc-inner {
  display: inline-block;
  cursor: pointer;
}
.md-toc-h1 .md-toc-inner {
  margin-left: 0px;
  font-weight: bold;
}
.md-toc-h2 .md-toc-inner {
  margin-left: 2em;
}
.md-toc-h3 .md-toc-inner {
  margin-left: 4em;
}
.md-toc-h4 .md-toc-inner {
  margin-left: 6em;
}
.md-toc-h5 .md-toc-inner {
  margin-left: 8em;
}
.md-toc-h6 .md-toc-inner {
  margin-left: 10em;
}
@media screen and (max-width: 48em) {
  .md-toc-h3 .md-toc-inner {
    margin-left: 3.5em;
  }
  .md-toc-h4 .md-toc-inner {
    margin-left: 5em;
  }
  .md-toc-h5 .md-toc-inner {
    margin-left: 6.5em;
  }
  .md-toc-h6 .md-toc-inner {
    margin-left: 8em;
  }
}
a.md-toc-inner {
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
}
.footnote-line a:not(.reversefootnote) {
  color: inherit;
}
.md-attr {
  display: none;
}
.md-fn-count::after {
  content: ".";
}
.md-tag {
  opacity: 0.5;
}
.md-comment {
  color: rgb(162, 127, 3);
  opacity: 0.8;
  font-family: monospace;
}
code {
  text-align: left;
}
h1 .md-tag,
h2 .md-tag,
h3 .md-tag,
h4 .md-tag,
h5 .md-tag,
h6 .md-tag {
  font-weight: initial;
  opacity: 0.35;
}
a.md-print-anchor {
  border: none !important;
  display: inline-block !important;
  position: absolute !important;
  width: 1px !important;
  right: 0px !important;
  outline: none !important;
  background-color: transparent !important;
  text-shadow: initial !important;
  background-position: initial initial !important;
  background-repeat: initial initial !important;
}
.md-inline-math .MathJax_SVG .noError {
  display: none !important;
}
.mathjax-block .MathJax_SVG_Display {
  text-align: center;
  margin: 1em 0em;
  position: relative;
  text-indent: 0px;
  max-width: none;
  max-height: none;
  min-height: 0px;
  min-width: 100%;
  width: auto;
  display: block !important;
}
.MathJax_SVG_Display,
.md-inline-math .MathJax_SVG_Display {
  width: auto;
  margin: inherit;
  display: inline-block !important;
}
.MathJax_SVG .MJX-monospace {
  font-family: monospace;
}
.MathJax_SVG .MJX-sans-serif {
  font-family: sans-serif;
}
.MathJax_SVG {
  display: inline;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  zoom: 90%;
  text-indent: 0px;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  float: none;
  direction: ltr;
  max-width: none;
  max-height: none;
  min-width: 0px;
  min-height: 0px;
  border: 0px;
  padding: 0px;
  margin: 0px;
}
.MathJax_SVG * {
  transition: none;
}

@include-when-export url(http://fonts.googleapis.com/css?family=Open+Sans:400italic,700italic,700,400&subset=latin,latin-ext);

/**
 * css forked from https://github.com/GitbookIO/gitbook
 * www.gitbook.com
 * Apache License
 * https://github.com/GitbookIO/gitbook/blob/master/LICENSE
 **/

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  src: local("Open Sans Regular"),
    url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/400.woff")
      format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: normal;
  src: local("Open Sans Italic"),
    url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/400i.woff")
      format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: bold;
  src: local("Open Sans Bold"),
    url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/700.woff")
      format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: bold;
  src: local("Open Sans Bold Italic"),
    url("file:///Users/HuminiOS/Library/Application%20Support/abnerworks.Typora/themes/github/700i.woff")
      format("woff");
}

html {
  font-size: 16px;
}

body {
  font-family: "Open Sans", "Clear Sans", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: rgb(51, 51, 51);
  line-height: 1.6;
}

#write {
  max-width: 860px;
  margin: 0 auto;
  padding: 20px 30px 40px 30px;
  padding-top: 20px;
  padding-bottom: 100px;
}
#write > ul:first-child,
#write > ol:first-child {
  margin-top: 30px;
}

body > *:first-child {
  margin-top: 0 !important;
}
body > *:last-child {
  margin-bottom: 0 !important;
}
a {
  color: #4183c4;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  position: relative;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
  line-height: 1.4;
  cursor: text;
}
h1:hover a.anchor,
h2:hover a.anchor,
h3:hover a.anchor,
h4:hover a.anchor,
h5:hover a.anchor,
h6:hover a.anchor {
  /*background: url("file:///Users/HuminiOS/Library/Application%20Support/images/modules/styleguide/para.png") no-repeat 10px center;*/
  text-decoration: none;
}
h1 tt,
h1 code {
  font-size: inherit;
}
h2 tt,
h2 code {
  font-size: inherit;
}
h3 tt,
h3 code {
  font-size: inherit;
}
h4 tt,
h4 code {
  font-size: inherit;
}
h5 tt,
h5 code {
  font-size: inherit;
}
h6 tt,
h6 code {
  font-size: inherit;
}
h1 {
  padding-bottom: 0.3em;
  font-size: 2.25em;
  line-height: 1.2;
  border-bottom: 1px solid #eee;
}
h2 {
  padding-bottom: 0.3em;
  font-size: 1.75em;
  line-height: 1.225;
  border-bottom: 1px solid #eee;
}
h3 {
  font-size: 1.5em;
  line-height: 1.43;
}
h4 {
  font-size: 1.25em;
}
h5 {
  font-size: 1em;
}
h6 {
  font-size: 1em;
  color: #777;
}
p,
blockquote,
ul,
ol,
dl,
table {
  margin: 0.8em 0;
}
li > ol,
li > ul {
  margin: 0 0;
}
hr {
  height: 4px;
  padding: 0;
  margin: 16px 0;
  background-color: #e7e7e7;
  border: 0 none;
  overflow: hidden;
  box-sizing: content-box;
  border-bottom: 1px solid #ddd;
}

body > h2:first-child {
  margin-top: 0;
  padding-top: 0;
}
body > h1:first-child {
  margin-top: 0;
  padding-top: 0;
}
body > h1:first-child + h2 {
  margin-top: 0;
  padding-top: 0;
}
body > h3:first-child,
body > h4:first-child,
body > h5:first-child,
body > h6:first-child {
  margin-top: 0;
  padding-top: 0;
}
a:first-child h1,
a:first-child h2,
a:first-child h3,
a:first-child h4,
a:first-child h5,
a:first-child h6 {
  margin-top: 0;
  padding-top: 0;
}
h1 p,
h2 p,
h3 p,
h4 p,
h5 p,
h6 p {
  margin-top: 0;
}
li p.first {
  display: inline-block;
}
ul,
ol {
  padding-left: 30px;
}
ul:first-child,
ol:first-child {
  margin-top: 0;
}
ul:last-child,
ol:last-child {
  margin-bottom: 0;
}
blockquote {
  border-left: 4px solid #dddddd;
  padding: 0 15px;
  color: #777777;
}
blockquote blockquote {
  padding-right: 0;
}
table {
  padding: 0;
  word-break: initial;
}
table tr {
  border-top: 1px solid #cccccc;
  background-color: white;
  margin: 0;
  padding: 0;
}
table tr:nth-child(2n) {
  background-color: #f8f8f8;
}
table tr th {
  font-weight: bold;
  border: 1px solid #cccccc;
  text-align: left;
  margin: 0;
  padding: 6px 13px;
}
table tr td {
  border: 1px solid #cccccc;
  text-align: left;
  margin: 0;
  padding: 6px 13px;
}
table tr th:first-child,
table tr td:first-child {
  margin-top: 0;
}
table tr th:last-child,
table tr td:last-child {
  margin-bottom: 0;
}

.CodeMirror-gutters {
  border-right: 1px solid #ddd;
}

.md-fences,
code,
tt {
  border: 1px solid #ddd;
  background-color: #f8f8f8;
  border-radius: 3px;
  padding: 0;
  font-family: Consolas, "Liberation Mono", Courier, monospace;
  padding: 2px 4px 0px 4px;
  font-size: 0.9em;
}

.md-fences {
  margin-bottom: 15px;
  margin-top: 15px;
  padding: 0.2em 1em;
  padding-top: 8px;
  padding-bottom: 6px;
}
.task-list {
  padding-left: 0;
}

.task-list-item {
  padding-left: 32px;
}

.task-list-item input {
  top: 3px;
  left: 8px;
}

@media screen and (min-width: 914px) {
  /*body {
        width: 854px;
        margin: 0 auto;
    }*/
}
@media print {
  html {
    font-size: 13px;
  }
  table,
  pre {
    page-break-inside: avoid;
  }
  pre {
    word-wrap: break-word;
  }
}

.md-fences {
  background-color: #f8f8f8;
}
#write pre.md-meta-block {
  padding: 1rem;
  font-size: 85%;
  line-height: 1.45;
  background-color: #f7f7f7;
  border: 0;
  border-radius: 3px;
  color: #777777;
  margin-top: 0 !important;
}

.mathjax-block > .code-tooltip {
  bottom: 0.375rem;
}

#write > h3.md-focus:before {
  left: -1.5625rem;
  top: 0.375rem;
}
#write > h4.md-focus:before {
  left: -1.5625rem;
  top: 0.285714286rem;
}
#write > h5.md-focus:before {
  left: -1.5625rem;
  top: 0.285714286rem;
}
#write > h6.md-focus:before {
  left: -1.5625rem;
  top: 0.285714286rem;
}
.md-image > .md-meta {
  border: 1px solid #ddd;
  border-radius: 3px;
  font-family: Consolas, "Liberation Mono", Courier, monospace;
  padding: 2px 4px 0px 4px;
  font-size: 0.9em;
  color: inherit;
}

.md-tag {
  color: inherit;
}

.md-toc {
  margin-top: 20px;
  padding-bottom: 20px;
}

#typora-quick-open {
  border: 1px solid #ddd;
  background-color: #f8f8f8;
}

#typora-quick-open-item {
  background-color: #fafafa;
  border-color: #fefefe #e5e5e5 #e5e5e5 #eee;
  border-style: solid;
  border-width: 1px;
}

#md-notification:before {
  top: 10px;
}

/** focus mode */
.on-focus-mode blockquote {
  border-left-color: rgba(85, 85, 85, 0.12);
}

header,
.context-menu,
.megamenu-content,
footer {
  font-family: "Segoe UI", "Arial", sans-serif;
}
</style>
